import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { isManualFlowLowQualityLayersEnabled } from 'user/selectors';
import ZoneGenerationCciYearSelection from './ZoneGenerationCciYearSelection';
import ZoneGenerationCciImageSelection from './ZoneGenerationCciImageSelection';

const ZoneGenerationCciContent = () => {
  const isManualFlowLowQualityLayers = useSelector(isManualFlowLowQualityLayersEnabled);

  return (
    <>
      <ZoneGenerationCciYearSelection isManualFlowLowQualityLayers={isManualFlowLowQualityLayers} />
      <ZoneGenerationCciImageSelection isManualFlowLowQualityLayers={isManualFlowLowQualityLayers} />
    </>
  );
};

export default memo(ZoneGenerationCciContent);
